import { observer } from "mobx-react-lite";
import { FC } from "react";
import { SyncState } from "@/components/sync/types";
import styled from "@emotion/styled";
import { SyncStatusIcon } from "@/components/sync/sync-status-icon";
import { SyncStatusText } from "@/components/sync/sync-status-text";

interface Props {
  syncState: SyncState;
}

export const SyncStatus: FC<Props> = observer(({ syncState }) => {
  return (
    <Label>
      <SyncStatusIcon syncState={syncState} />
      <SyncStatusText syncState={syncState} />
    </Label>
  );
});

const Label = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  gap: 6px;
  font-size: ${({ theme }) => theme.fontSizes["paragraph-s"]};
  line-height: ${({ theme }) => theme.lineHeights["paragraph-s"]};
  color: ${({ theme }) => theme.colors.text.secondary};
  padding-inline: ${({ theme }) => theme.spacing["5"]};
  padding-block: ${({ theme }) => theme.spacing["2"]};
`;
